<template>
  <section>
    <drivers-header title="Помощь" />
    <div class="driver">
      <div class="driver__title">Контакты</div>
      <div class="driver__description">
        Наши диспетчера помогут вам в&nbsp;оформлении документов
      </div>
      <div class="driver__content">
        <a href="tel:+79384444420" class="help flex-v-center">
          <div class="help__picture flex-center">
            <img src="@/assets/img/new-handset-green.svg" alt="phone ">
          </div>
          <div class="help__info flex-column-between">
            <div class="font-normal">Диспетчера</div>
            <div class="help__info-title font-bold mod-green">+7 938 444-44-20</div>
          </div>
        </a>
        <a href="tel:+79186368209" class="help flex-v-center">
          <div class="help__picture flex-center">
            <img src="@/assets/img/new-handset-green.svg" alt="phone ">
          </div>
          <div class="help__info flex-column-between">
            <div class="font-normal">Бухгалтерия</div>
            <div class="help__info-title font-bold mod-green">+7 918 636-82-09</div>
          </div>
        </a>
        <a href="https://wa.me/89384444420" class="help__button flex-center" target="_blank">
          <img src="@/assets/img/new-whatsapp.svg" alt="phone ">
          <span>Чат WhatsApp</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'
export default {
  name: 'HelpMobile',
  components: { DriversHeader },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.help
  margin-bottom: 2rem
  padding: 1.6rem
  box-shadow: 0 0 10px rgba(132, 132, 132, 0.15)
  border-radius: 1.2rem
  cursor: pointer
  &__info
    margin-left: 1.4rem
    .mod-green
      color: $mainColor
  &__picture
    width: 4.6rem
    height: 4.6rem
    background: #EBF9EB
    border-radius: .8rem
    img
      width: 2.4rem
      height: 2.4rem
  &__button
    width: 100%
    height: 5.2rem
    padding: 0
    font-size: 1.6rem
    font-weight: 800
    border-radius: 0.8rem
    background: $mainColor
    color: #FFFFFF
    cursor: pointer
    &:hover
      background: #00833C
    &:active
      background: #006421
    img
      width: 2.4rem
      height: 2.4rem
      margin-right: 0.8rem
</style>
